import M from "materialize-css"

// Inline template scripts use M (e.g. M.Modal), matching the old vendored
// build which set the global itself.
window.M = M

export default M
